import { useQuery } from '@tanstack/react-query';
import { killshotApi } from '../api';

const fetchFromAPI = async endpoint => {
  const response = await killshotApi.get(endpoint);
  return response;
};

const fetchMarketplaceListings = async (sgId = '', tnId = '') => {
  try {
    const endpoints = [];
    // If SG ID is different than 0, then fetch listings and map info
    if (sgId !== 0) {
      endpoints.push(`v2/seatgeek/listings/${sgId}`);
    }

    // If TN ID is different than 0, then fetch listings and map info
    if (tnId !== 0) {
      endpoints.push(`v2/ticketnetwork/listings/${tnId}`);
    }

    const promises = endpoints.map(fetchFromAPI);
    const responses = await Promise.all(promises);
    return responses;
  } catch (e) {
    return [];
  }
};

export const useQueryListingsAll = (eventId, sg, tn) => {
  const { data, error, isFetching, refetch, status } = useQuery({
    queryKey: ['listings/event', { eventId }],
    queryFn: () => fetchMarketplaceListings(sg, tn),
    refetchOnMount: true,
    staleTime: 1000 * 60 * 5, // 5 minute of cache,
    refetchOnWindowFocus: false,
  });
  return {
    data,
    error,
    isFetching,
    refetch,
    status,
  };
};

export const useQueryListings = eventMeta => {
  return useQueryListingsAll(eventMeta.event_id, eventMeta.seatgeek_id || 0, eventMeta.ticketnetwork_id || 0);
};
